import script from "./Vista_Clientes.vue?vue&type=script&setup=true&lang=js"
export * from "./Vista_Clientes.vue?vue&type=script&setup=true&lang=js"

import "./Vista_Clientes.vue?vue&type=style&index=0&id=51a8713c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-51a8713c"]])

export default __exports__